<template>
  <v-menu bottom left offset-y min-width="300px">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <p-avatar
          :color="currentUser.color"
          :char="currentUser.fullName[0]"
          :email="currentUser.email"
          :size="40"
        ></p-avatar>
      </v-btn>
    </template>
    <v-card outlined class="p-user-avatar-menu">
      <v-list class="py-0">
        <v-list-item
          v-if="hasAccess('write', 'profile')"
          :to="{ name: 'profile' }"
          class="py-1"
        >
          <p-avatar
            :color="currentUser.color"
            :char="currentUser.fullName[0]"
            :email="currentUser.email"
            :size="32"
            list-item-avatar
          ></p-avatar>
          <v-list-item-content>
            <v-list-item-title class="subtitle-2 ma-0">{{ currentUser.fullName }}</v-list-item-title>
            <v-list-item-subtitle class="p-caption">
              {{ $t('profile.seeProfile') }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
          v-else
          class="py-1"
        >
          <p-avatar
            :color="currentUser.color"
            :char="currentUser.fullName[0]"
            :email="currentUser.email"
            :size="32"
            list-item-avatar
          ></p-avatar>
          <v-list-item-content>
            <v-list-item-title class="subtitle-2 ma-0">{{ currentUser.fullName }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="mb-2"></v-divider>

        <v-list-item
          v-for="tenant of tenants"
          :key="tenant.name"
          @click.stop="switchTenant(tenant)"
        >
          <p-avatar
            :char="tenant.name[0]"
            :size="28"
            color="primary"
            list-item-avatar
          ></p-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ tenant.name }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-icon>
            <v-icon v-show="tenant.name === currentTenant" color="primary">mdi-check</v-icon>
          </v-list-item-icon>
        </v-list-item>

        <v-divider class="my-2"></v-divider>

        <v-list-item>
          <v-switch
            v-model="$vuetify.theme.dark"
            inset
            dense
            class="p-input-switch"
            @click.stop
            @change="onChangeTheme"
          ></v-switch>
          <v-list-item-content class="ml-n3">
            {{ $t('themeDarkSwitcherLabel') }}
          </v-list-item-content>
        </v-list-item>

        <v-divider class="my-2"></v-divider>

        <!-- <v-list-item :to="{ name: 'accountSettings' }">
          <v-list-item-icon>
            <v-icon>mdi-cog-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            {{ $t('nav.settings') }}
          </v-list-item-content>
        </v-list-item> -->

        <v-list-item @click="logout">
          <v-list-item-icon>
            <v-icon>mdi-exit-to-app</v-icon>
          </v-list-item-icon>
          <v-list-item-content class="ml-1">
            {{ $t('logout') }}
          </v-list-item-content>
        </v-list-item>

        <v-divider class="mt-2"></v-divider>

        <v-list-item class="justify-center">
          <a href="/privacy" class="p-caption">{{ $t('nav.privacy') }}</a>
          <span class="p-caption-dot mx-3">•</span>
          <a href="/terms" class="p-caption">{{ $t('nav.terms') }}</a>
        </v-list-item>
      </v-list>
    </v-card>
  </v-menu>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'

import PAvatar from '@/components/PAvatar'

import authMixin from '@/mixins/auth.mixin'
import themeMixin from '@/mixins/theme.mixin'
import accessMixin from '@/mixins/access.mixin'


export default {
  components: {
    PAvatar
  },


  mixins: [
    authMixin,
    themeMixin,
    accessMixin
  ],


  computed: {
    ...mapGetters('tenant', ['tenants', 'currentTenant']),
    ...mapGetters('user', ['currentUser'])
  },


  methods: {
    ...mapActions('tenant', ['setCurrentTenant']),

    switchTenant (tenant) {
      this.setCurrentTenant(tenant)
      window.location.reload()
    }
  }
}
</script>
